import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import moment from 'moment';

const emailTypes = [
  '[GEEQUIP]InviteSignup',
  '[GEEQUIP]InviteSignupBySuperAdmin',
  '[GEEQUIP]ForgotPassword'
]

const initialState = {
  emailLogs: { count: 0, rows: [] },
  emailLogsFilter: {
    page: 1,
    limit: 25,
    search: "",
    order: "desc",
    orderBy: "createdAt",
    startDate: moment().subtract(1, 'months'),
    endDate: null,
    filteredEmailTypes: [],
  },
  tenants: { count: 0, rows: [] },
  loadingTenants: false,
  emailTypes: emailTypes.map(et => ({ value: et, label: et })),
  emailLog: {},
  loading: false,
  loadingEmailLog: false,
};

const requestEmailLogsStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const requestEmailLogByIdStart = (state, action) => {
  return updateObject(state, { loadingEmailLog: true });
};

const fetchEmailLogsSuccess = (state, action) => {
  return updateObject(state, {
    emailLogs: action.logs,
    loading: false,
  });
};

const fetchEmailLogsByIdSuccess = (state, action) => {
  return updateObject(state, {
    emailLog: action.emailLog,
    loadingEmailLog: false
  });
}

const setEmailLogsFilter = (state, action) => {
  return updateObject(state, {
    emailLogsFilter: action.emailLogsFilter,
  });
};

const requestEmailLogsOptionsTenantsStart = (state, action) => {
  return updateObject(state, { loadingTenants: true });
};

const fetchEmailLogsOptionsTenantsSuccess = (state, action) => {
  return updateObject(state, {
    tenants: action.tenants,
    loadingTenants: false,
  });
};

const fetchEmailLogsOptionsTenantsFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loadingTenants: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_EMAIL_LOGS_START:
      return requestEmailLogsStart(state, action);
    case actionTypes.REQUEST_EMAIL_LOG_BY_ID_START:
      return requestEmailLogByIdStart(state, action);
    case actionTypes.FETCH_EMAIL_LOGS_SUCCESS:
      return fetchEmailLogsSuccess(state, action);
    case actionTypes.FETCH_EMAIL_LOG_BY_ID_SUCCESS:
      return fetchEmailLogsByIdSuccess(state, action);
    case actionTypes.SET_EMAIL_LOGS_FILTER:
      return setEmailLogsFilter(state, action);
    case actionTypes.REQUEST_EMAIL_LOGS_OPTIONS_TENANTS_START:
      return requestEmailLogsOptionsTenantsStart(state, action);
    case actionTypes.FETCH_EMAIL_LOGS_OPTIONS_TENANTS_SUCCESS:
      return fetchEmailLogsOptionsTenantsSuccess(state, action);
    case actionTypes.FETCH_EMAIL_LOGS_OPTIONS_TENANTS_FAIL:
      return fetchEmailLogsOptionsTenantsFail(state, action);
    default:
      return state;
  }
};

export default reducer;
